<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div class="v3-link-dialog">
  <div class="v3-link-dialog__header">
    <h2 class="v3-link-dialog__title subsection-title">{{ 'translations.dialog.title.addLink' | transloco }}</h2>
    <button
      type="button"
      class="v3-link-dialog__close"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
    >
      <ptl-icon [icon]="LucideX" [size]="'m'"></ptl-icon>
    </button>
  </div>

  <div class="v3-link-dialog__body" (keydown.enter)="onEnter($event)">
    <ptl-sg-input
      data-testid="link-dialog-url"
      type="url"
      [formControl]="urlControl"
      [placeholder]="'translations.mediaContent.label.uploadImagePlaceholder' | transloco"
      [ariaLabel]="'translations.dialog.title.addLink' | transloco"
      [invalid]="showUrlError() || summaryUnavailable()"
      (inputChange)="onUrlChanged()"
    ></ptl-sg-input>
    @if (showUrlError()) {
      <p class="v3-link-dialog__error fs-body-xs-normal">{{ 'translations.mediaContent.message.error.invalidUrl' | transloco }}</p>
    } @else if (summaryUnavailable()) {
      <p class="v3-link-dialog__error fs-body-xs-normal">
        {{ 'translations.mediaContent.message.error.unavailableExternalContentSummary' | transloco }}
      </p>
    }
  </div>

  <div class="v3-link-dialog__actions">
    <ptl-button
      type="secondary-neutral"
      size="s"
      [text]="'translations.global.button.cancel' | transloco"
      (clicked)="closeDialog()"
    ></ptl-button>
    <ptl-button
      type="primary"
      size="s"
      data-testid="link-dialog-add"
      [loading]="fetchingSummary()"
      [text]="'translations.global.button.addLink' | transloco"
      (clicked)="onAdd()"
    ></ptl-button>
  </div>
</div>
